import { ReactNode } from "react";

interface FooterColumnProps {
  title: string;
  children: ReactNode;
  className?: string;
}

/** Column container for footer link groups. */
export function FooterColumn({
  title,
  children,
  className = "",
}: FooterColumnProps) {
  return (
    <div className={`text-center md:text-left ${className}`}>
      <h3 className="text-lg font-semibold text-foreground mb-4">{title}</h3>
      <ul className="space-y-2">{children}</ul>
    </div>
  );
}
